<template>
  <div>
    <PageMain
      :tableData="tableData"
      :loading="loading"
      @edit="edit"
      @remove="remove"
    >
      <template #header>
        <div class="section-header-wrapper">
          <div class="section-header">
            <span class="section-bar" />
            <span class="section-title">{{
              $l('section_booking_record') || '订舱记录'
            }}</span>
          </div>

          <el-button
            type="primary"
            plain
            size="mini"
            @click="edit({ type: 'add' })"
          >
            {{ $l('btn_add_booking') || '新增订舱' }}
          </el-button>
        </div>
      </template>
    </PageMain>

    <EditBooking
      :type="editOpts.type"
      :visible.sync="editOpts.visible"
      :shipmentCode="shipmentCode"
      :shipmentBookingCode="editOpts.shipmentBookingCode"
      @reload="reload"
    />
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import PageMain from './main.vue'
import EditBooking from '../edit-booking/index.vue'

export default {
  components: { PageMain, EditBooking },
  mixins: [EditLoading],
  props: {
    shipmentCode: { type: String, default: '' },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      editOpts: {
        type: '',
        visible: false,
        shipmentBookingCode: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    reload() {
      this.getData()
    },
    async getData() {
      if (!this.shipmentCode) return

      this.loading = true
      const res = await this.$api
        .ecomShipmentBookingListApi({ shipmentCode: this.shipmentCode })
        .catch(() => null)
      this.loading = false
      if (!res) return

      this.tableData = res.body?.data || []
    },
    edit({ type = 'add', row = {} } = {}) {
      const { shipmentBookingCode } = row

      this.editOpts = {
        type,
        visible: true,
        shipmentBookingCode,
      }
    },
    async remove({ shipmentBookingCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_delete_booking') || '确认删除该订舱记录吗？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomShipmentBookingDelApi({ shipmentBookingCode })
        .catch(() => null)
      this.loadingClose()

      if (!res) return

      const { status, msg } = res
      const error = status !== 200

      this.$message({
        showClose: true,
        message: msg,
        type: error ? 'error' : 'success',
      })

      if (error) return

      this.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
.section-header-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;

  .section-header {
    display: flex;
    align-items: center;
    gap: 8px;

    .section-bar {
      width: 3px;
      height: 16px;
      border-radius: 2px;
      background: #409eff;
    }
    .section-title {
      font-size: 14px;
      font-weight: 600;
      color: #334155;
    }
    .section-count {
      font-size: 11px;
      font-weight: 400;
      color: #94a3b8;
      margin-left: 5px;
    }
  }
}
</style>
